module.exports = __webpack_public_path__ + "assets/img/58_213_4.ae165614.jpg";